import { ProcessorDetails } from '@/lib/api/processors';
import { ProcessorHeader } from '../components/processor-header';
import { ProcessorOverviewCard } from '../components/processor-overview-card';
import { ProcessorMetricsCard } from '../components/processor-metrics-card';
import { RouteSenseConfigurationCard } from './components/routesense-configuration-card';

interface RouteSenseProcessorDetailsPageProps {
  processor: ProcessorDetails;
}

export const RouteSenseProcessorDetailsPage = ({ processor }: RouteSenseProcessorDetailsPageProps) => {
  return (
    <>
      <ProcessorHeader type="routesense" processor={processor} />
      <ProcessorOverviewCard processor={processor} />
      <ProcessorMetricsCard processor={processor} />
      <RouteSenseConfigurationCard processor={processor} />
    </>
  );
};
